// import React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { CapexOpexClobDto } from 'models/dtoTypes';
import SubSection from './_subSection';
import Empty from './_empty';
import { useTranslation } from 'react-i18next';

const PREFIX = 'CapexOpexReport';

const classes = {
  report: `${PREFIX}-report`,
};

const Root = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  [`& .${classes.report}`]: {},
}));

interface IProps {
  name?: string;
  capexOpexReport: CapexOpexClobDto[];
}

export default function CapexOpexReport(props: IProps): JSX.Element {
  const { t } = useTranslation('default');
  const {
    name = t(
      'this-individual-has-provided-us-with-the-following-selfreported-information-on-eu-taxonomy-expenditure',
    ),
    capexOpexReport,
  } = props;

  const renderContent = () => {
    if (capexOpexReport.length === 0) {
      return <Empty title={t('there-is-no-data-available')} />;
    }

    return (
      <Root>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow
              sx={{
                '& td, & th': {
                  borderBottom: '2px solid #808080',
                  pt: 1,
                  pb: 1,
                },
              }}
            >
              <TableCell></TableCell>
              <TableCell align="left">XX% of {t('turnover-spent')}</TableCell>
              <TableCell align="left">XX% of {t('capital-expenditure')}</TableCell>
              <TableCell align="left">XX% of {t('operational-expenditure')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {capexOpexReport.map((row) => (
              <TableRow
                key={row.title}
                sx={{
                  '& td, & th': {
                    borderBottom: '2px solid #808080',
                    pt: 1,
                    pb: 1,
                  },
                  '& td': {
                    fontWeight: 'bold',
                  },
                }}
              >
                <TableCell component="th" scope="row">
                  {row.title}
                </TableCell>
                <TableCell align="left">{row.spendPercentTurnover}</TableCell>
                <TableCell align="left">{row.spendPercentCapEx}</TableCell>
                <TableCell align="left">{row.spendPercentOpEx}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Root>
    );
  };

  return <SubSection title={name}>{renderContent()}</SubSection>;
}
